import { ChangeDetectorRef, Component } from '@angular/core';
import { MessageService } from 'primeng/api';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { Toolbar } from 'primeng/toolbar';
import { InputIcon } from 'primeng/inputicon';
import { IconField } from 'primeng/iconfield';
import { InputText } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';

import { TableModule } from 'primeng/table';
import { NewUserComponent } from "../new-user/new-user.component";
import { EditUserComponent } from "../edit-user/edit-user.component";
import { User } from '../../../../core/interfaces/user';
import { AccountApiService } from '../../../../core/services/account-api.service';
import { UsersApiService } from '../../../../core/services/users-api.service';
import { SelectInput } from '../../../../shared/interfaces/select-input';
import { BooleanToYesNoPipe } from '../../../../shared/pipes/boolean-to-yes-no.pipe';
import { RolePipe } from '../../../../shared/pipes/role.pipe';
import { PaginatorModule } from 'primeng/paginator';
import { UserDetailsComponent } from "../user-details/user-details.component";
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { passwordLinkObserver } from '../../../../core/utils/password-link';


@Component({
  selector: 'app-users',
  imports: [ButtonModule, TableModule, DialogModule,
    ToastModule, Toolbar, InputIcon, IconField, FormsModule, InputText, MultiSelectModule,
    ReactiveFormsModule, BooleanToYesNoPipe, RolePipe, NewUserComponent, EditUserComponent,
    PaginatorModule, UserDetailsComponent, BlockUIModule, ProgressSpinnerModule],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss',
  providers: [ BooleanToYesNoPipe]
})
export class UsersComponent {
  name!: string;
  blockedDocument = false;
  visible = false
  editVisible = false 
  editUser!: User
  viewVisible = false 
  viewUser!: User  
  users!: User[]
  accountOptions: SelectInput[] = []


  constructor(private usersApi: UsersApiService, private messageService: MessageService, 
    private accountApi: AccountApiService, private cdr: ChangeDetectorRef
  ) {
    this.loadUsers()
    this.loadAccounts()
  }

  loadUsers() {
    this.blockedDocument = true;
    this.usersApi.getUsers().subscribe({
        next: (data) =>{
          this.users = data;
          this.visible = false;
          this.blockedDocument = false;
        } ,
        error: (err) => {
          this.blockedDocument = false;
          console.error('Error fetching data', err)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'I was not possible to load the users list.', life: 5000 })

        }

    })
  }


  showDialog() {
    this.visible = true
  }

  showEditUser(user: User) {
    this.editUser = user
    this.editVisible = true
  }

  showUser(user: User) {
    this.viewUser = user
    this.viewVisible = true
  }

  sendPasswordLink(user: User) {
    this.usersApi.sendPasswordLink(user.id!).subscribe(passwordLinkObserver(this.messageService));
  }

  closeEditDialog(event: any) {
    this.editVisible = false
    this.loadUsers()
  }

  closeDialog(event: any) {
    this.visible = false
    this.loadUsers()
  }

  closeViewDialog(event: any) {
    this.viewVisible = false
  }

  loadAccounts() {
    const userRoles = localStorage.getItem('roles')?.split(',');
    //if role_sys_admin load all accounts, else loads only user account
    if (userRoles?.includes("ROLE_SYS_ADMIN")) {
      this.accountApi.getAccounts().subscribe({
        next: (data) => {
          for(let item of data) {
            this.accountOptions.push({label: item.name, code: item.id})         
          }
        }
        
      })
    }
  }

  get filteredItems() {
    if(this.users) {
          return this.users.filter(item =>
            (!this.name || item!.username!.toLowerCase().includes(this.name.toLowerCase())) 
            &&
            (!this.name || item!.email!.toLowerCase().includes(this.name.toLowerCase()))
    ); }
    return [];
  }
  
}
